/* import __COLOCATED_TEMPLATE__ from './lsg-layout-bubble-container.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

const CLASS_NAME = 'LSG-l-bubble-container';

class LsgLayoutBubbleContainer extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.args.isOnlySmallAndDownFlatEdges && `${CLASS_NAME}--only-small-and-down-flat-edges`,
      this.args.hasHoverShadow && `${CLASS_NAME}--has-hover-shadow`,
      this.args.hasGrayBackground && `${CLASS_NAME}--has-gray-background`,
    );
  }
}

export default LsgLayoutBubbleContainer;
